module.exports = __webpack_public_path__ + "img/AW.a35dda89.svg";